<template>
  <section class="operation">
    <h1>{{ textData[lang.key].operation.title }}</h1>
    <div
      v-if="mediaType === 'pc'">
      <div
        v-for="num in contentsNum"
        :key="num"
        class="operation__block">
        <div class="operation__block_text">
          <p class="no">
            {{ num }}
          </p>
          <div class="textbox">
            <p>{{ textData[lang.key].operation['text' + num] }}</p>
          </div>
        </div>
        <img
          :src="require('../../assets/img/img-app' + num + '.png')">
      </div>
    </div>
    <div
      v-else
      class="operation__slider">
      <div class="bk"/>
      <slick
        ref="slick"
        :options="slickOptions">
        <div
          v-for="num in contentsNum"
          :key="num"
          class="operation__slider">
          <img
            :src="require('../../assets/img/img-app' + num + '.png')">
          <div class="operation__slider_text">
            <span class="no">
              {{ num }}
            </span>
            <p>{{ textData[lang.key].operation['text' + num] }}</p>
          </div>
        </div>
      </slick>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  name: 'Operation',
  components: {
    setting,
    mapGetters,
    Slick
  },
  computed: {
    ...mapGetters(['textData', 'lang', 'mediaType'])
  },
  data () {
    return {
      setting,
      contentsNum: 5,
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
    if (this.$refs.slick && !this.$refs.slick.$el.classList.contains('slick-initialized')) {
      this.$refs.slick.create(this.slickOptions)
    }
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  },
  watch: {
    'lang': function () {
      console.log('this.$refs.slick:', this.$refs.slick)
      if (this.$refs.slick) {
        // closedにある文章の言語が切り替わらないのでリセットする
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .operation {
    width: 100%;
    padding-bottom: 30px;
    & h1 {
      color: #CC3454;
      font-size: 40px;
      text-align: center;
      padding: 70px 0;
    }
    &__block {
      display: flex;
      max-width: 820px;
      margin: 0 auto 40px;
      &_text {
        width: calc(100% - 236px);
        padding-right: 40px;
        & .no {
          color: #BBBBBB;
          font-size: 160px;
          line-height: 160px;
          font-family: helvetica!important;
          margin-bottom: 10px;
        }
        & .textbox {
          display: flex;
          align-items: center;
          color: #222222;
          background: #F0F0F0;
          font-size: 16px;
          white-space: pre-line;
          height: 200px;
          margin: 0 -2000px;
          padding: 0 2000px;
        }
      }
      & img {
        width: 236px;
        height: 420px;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      }
    }
  }
  @media (--breakPoint) {
    .operation {
      position: relative;
      width: 100%;
      /* height: 100vh; */
      /* max-height: 710px; */
      padding-bottom: 0;
      & h1 {
        font-size: 28px;
        padding: 40px 0;
      }
      &__slider {
        font-size: 0;
        transition: all 300ms ease;
        .bk {
          position: absolute;
          background: #F0F0F0;
          width: 100%;
          height: 50%;
          bottom: 0;
        }
        & img {
          position: inherit;
          z-index: 1000;
          width: calc(100% - 200px);
          max-width: 200px;
          height: auto;
          margin: 0 auto;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }
        &_text {
          position: relative;
          padding: 15px 40px 15px 65px;
          & .no {
            position: absolute;
            top: 15px;
            left: 35px;
            color: #BBBBBB;
            font-size: 35px;
            line-height: 35px;
            font-family: helvetica!important;
          }
          & p {
            color: #222222;
            font-size: 14px;
            line-height: 18px;
            white-space: pre-line;
          }
        }
      }
    }
    #app.en .operation,
    #app.ru .operation,
    #app.fr .operation,
    #app.de .operation,
    #app.es .operation,
    #app.it .operation {
      p {
        font-size: 13px;
        line-height: 17px;
      }
    }
  }
  /* 一部端末でだとどうしてもdotが隠れてしまう為 */
  @media (--info-phoneSE) {
    .operation {
      &__slider {
        &_text {
          padding: 12px 30px 12px 60px;
          & .no {
            left: 30px;
          }
          & p {
            font-size: 13px;
            line-height: 16px;
          }
        }
      }
    }
    #app.en .operation,
    #app.ru .operation,
    #app.fr .operation,
    #app.de .operation,
    #app.es .operation,
    #app.it .operation {
      &__slider {
        &_text {
          padding: 10px 20px 10px 50px;
          & .no {
            left: 20px;
          }
          & p {
            font-size: 12px;
            line-height: 15px;
          }
        }
      }
    }
  }
</style>
<style>
.operation__slider .slick-dotted.slick-slider {
  margin-bottom: 0px;
}
.operation__slider .slick-dots {
  bottom: 0;
  position: relative;
  padding: 10px 0 40px;
}
.operation__slider .slick-dots li button:before {
  color: #222222;
  font-size: 10px;
}
/* dot押した時にhoverが残ってしまう為 */
.operation__slider .slick-dots li.slick-active button:before {
  opacity: 1!important;
  color: #CC3454;
}
.operation__slider .slick-dots li button:hover:before {
    opacity: 0.25;
}</style>



// WEBPACK FOOTER //
// src/components/templates/Operation.vue